import React, { Fragment, useEffect, useState } from 'react';
import { useStoreState, useStoreActions } from 'easy-peasy';
import { useTheme } from '@mui/material/styles';
import {
	Stack,
	Typography,
	Button,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	FormControl,
	Select,
	MenuItem,
	CircularProgress
} from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import CloseIcon from '@mui/icons-material/Close';
import AddTaskIcon from '@mui/icons-material/AddTask';
import utils from 'components/utils';

const AddExtraConditions = props => {
	const { item } = props;
	const theme = useTheme();
	const translate = utils.useI18N();
	const loadingPromotions = useStoreState(state => state.wishlist.addExtraConditions.loadingPromotions);
	const loadingAdd = useStoreState(state => state.wishlist.addExtraConditions.loadingAdd);
	const promotions = useStoreState(state => state.wishlist.addExtraConditions.promotions);
	const infoItem = useStoreState(state => state.wishlist.addExtraConditions.infoItem);
	const loadPromotions = useStoreActions(dispatch => dispatch.wishlist.addExtraConditions.loadPromotions);
	const selectPromotion = useStoreActions(dispatch => dispatch.wishlist.addExtraConditions.selectPromotion);
	const updatePromotions = useStoreActions(dispatch => dispatch.wishlist.addExtraConditions.updatePromotions);
	const promoSelected = promotions ? promotions.filter(p => p.isSelected) : [];
	const promoCodeSelected = promoSelected.length > 0 ? promoSelected[0].sapPromoId : '_empty_';
	const disableButton = promoSelected.length == 0 || promoSelected[0].sapPromoId === '_empty_';
	const [open, setOpen] = useState(false);

	useEffect(() => {
		if (promotions.length == 0) loadPromotions(item.promoCode);
	}, []);

	useEffect(() => {
		if (promotions.length > 0) {
			selectPromotion(infoItem[item.id] ? infoItem[item.id] : item.promoCode ? item.promoCode : '_empty_');
		}
	}, [promotions.length]);

	const handleClose = () => {
		setOpen(false);
	};

	const handleAdd = _ => {
		updatePromotions({
			idWishlist: item.id,
			sapPromoId: promoSelected[0].sapPromoId === '_empty_' ? '' : promoSelected[0].sapPromoId,
			sapName: promoSelected[0].sapPromoId === '_empty_' ? '' : promoSelected[0].name
		});
		setOpen(false);
	};

	return (
		<Fragment>
			<Button variant="dark" onClick={_ => setOpen(true)}>
				{translate('wishlistSpecial.addExtraCondiction')}
			</Button>
			<Dialog open={open} onClose={handleClose} aria-labelledby="responsive-dialog-title">
				<DialogTitle
					id="responsive-dialog-title"
					sx={{
						marginBottom: '-10px !important',
						paddingRight: '16px !important',
						paddingLeft: '16px !important'
					}}
				>
					{translate('wishlistSpecial.addExtraCondiction')}
				</DialogTitle>
				<DialogContent>
					<Stack
						direction="column"
						justifyContent="flex-start"
						alignItems="flex-start"
						spacing={1}
						sx={{
							width: '100%',
							borderWidth: '1px 0 0 0',
							borderStyle: 'solid',
							borderColor: theme.palette.primary.main,
							paddingTop: '15px !important',
							paddingRight: '16px !important',
							paddingLeft: '16px !important',
							minWidth: { xs: '220px', md: '520px', sm: '520px' }
						}}
					>
						<Typography variant="text" sx={{ fontWeight: '600' }}>
							{translate('wishlistSpecial.wishlistSpecial') + ': ' + item.name}
						</Typography>
						{loadingPromotions && (
							<CircularProgress sx={{ fontSize: '36px', color: theme.palette.primary.main }} />
						)}
						{!loadingPromotions && (
							<FormControl variant="outlined" sx={{ width: '100%', maxWidth: '320px' }}>
								<Select
									value={promoCodeSelected}
									displayEmpty
									onChange={event => selectPromotion(event.target.value)}
								>
									{promotions.map((item, index) => (
										<MenuItem key={item.sapPromoId} value={item.sapPromoId}>
											{item.name}
										</MenuItem>
									))}
								</Select>
							</FormControl>
						)}
					</Stack>
				</DialogContent>
				<DialogActions>
					<Stack
						direction="row"
						justifyContent="space-between"
						alignItems="center"
						spacing={0}
						sx={{ width: '100%' }}
					>
						<Button variant="light" onClick={handleClose} endIcon={<CloseIcon />}>
							{translate('common.cancel')}
						</Button>
						<LoadingButton
							variant="dark"
							//disabled={disableButton}
							onClick={handleAdd}
							endIcon={<AddTaskIcon />}
							loading={loadingAdd}
							loadingPosition="end"
						>
							{translate('common.confirm')}
						</LoadingButton>
					</Stack>
				</DialogActions>
			</Dialog>
		</Fragment>
	);
};

export default AddExtraConditions;
